module.exports = require("@swa-ui/core/src/Endow/Endow.module.scss");